<script>
import { mapActions, mapMutations, mapState } from "vuex";

const propertyTypeOptions = ['Apartments', 'Townhouses', 'House & Land', 'House', 'Land'];
const propertyTypeChipOptions = [
  {key:"All", value:"All Types"},
  {key:"Apartments", value:"Apartments"},
  {key:"Townhouses", value:"Townhouses"},
  {key:"House & Land", value:"House & Land"},
  {key:"House", value:"House"},
  {key:"Land", value:"Land"}
];
export default {
  name: "searchSection",
  data() {
    return {
      searchType: "buy",
      searchSuburb: "",
      isSearchFiltersDialogVisible: false,
      filterBadgeValueCount: 0,
      searchFiltersForm: {
        sort: "time",
        saleType: "1",
        propertyTypeList: [],
        minPrice: null,
        maxPrice: null,
        minRentalEstimate: null,
        maxRentalEstimate: null,
        minLandSize: null,
        maxLandSize: null,
        minBuildSize: null,
        maxBuildSize: null,
        minBedrooms: null,
        maxBedrooms: null,
        bathrooms: null,
        carSpaces: null,
        searchSuburb: "",
        searchType: "",
      },
      selectedMinPrice: "Any",
      selectedMaxPrice: "Any",
      selectedMinRentalEstimate: "Any",
      selectedMaxRentalEstimate: "Any",
      selectedMinLandSize: "Any",
      selectedMaxLandSize: "Any",
      selectedMinBuildSize: "Any",
      selectedMaxBuildSize: "Any",
      selectedMinBedrooms: "Any",
      selectedMaxBedrooms: "Any",
      selectedBathrooms: "Any",
      selectedCarSpaces: "Any",
      suburbList: [
        "South Austtralia",
        "All Suburbs",
        "Bowden",
        "Parafield Gardens",
      ],
      minPrice: [
        { id: 0, label : "Any",  value: null },
        { id: 1, label : "50000",  value: 50000 },
        { id: 2, label : "75000",  value: 75000 },
        { id: 3, label : "100000",  value: 100000 },
        { id: 4, label : "125000",  value: 125000 },
        { id: 5, label : "150000",  value: 150000 },
        { id: 6, label : "175000",  value: 175000 },
        { id: 7, label : "200000",  value: 200000 },
        { id: 8, label : "225000",  value: 225000 },
        { id: 9, label : "250000",  value: 250000 },
        { id: 10, label : "275000",  value: 275000 },
        { id: 11, label : "300000",  value: 300000 },
        { id: 12, label : "325000",  value: 325000 },
        { id: 13, label : "350000",  value: 350000 },
        { id: 14, label : "375000",  value: 375000 },
        { id: 15, label : "400000",  value: 400000 },
        { id: 16, label : "425000",  value: 425000 },
        { id: 17, label : "450000",  value: 450000 },
        { id: 18, label : "475000",  value: 475000 },
        { id: 19, label : "500000",  value: 500000 },
        { id: 20, label : "550000",  value: 550000 },
        { id: 21, label : "600000",  value: 600000 },
        { id: 22, label : "650000",  value: 650000 },
        { id: 23, label : "700000",  value: 700000 },
        { id: 24, label : "750000",  value: 750000 },
        { id: 25, label : "800000",  value: 800000 },
        { id: 26, label : "850000",  value: 850000 },
        { id: 27, label : "900000",  value: 900000 },
        { id: 28, label : "950000",  value: 950000 },
        { id: 29, label : "1000000",  value: 1000000 },
        { id: 30, label : "1100000",  value: 1100000 },
        { id: 31, label : "1200000",  value: 1200000 },
        { id: 32, label : "1300000",  value: 1300000 },
        { id: 33, label : "1400000",  value: 1400000 },
        { id: 34, label : "1500000",  value: 1500000 },
        { id: 35, label : "1600000",  value: 1600000 },
        { id: 36, label : "1700000",  value: 1700000 },
        { id: 37, label : "1800000",  value: 1800000 },
        { id: 38, label : "1900000",  value: 1900000 },
        { id: 39, label : "2000000",  value: 2000000 },
        { id: 40, label : "2250000",  value: 2250000 },
        { id: 41, label : "2500000",  value: 2500000 },
        { id: 42, label : "2750000",  value: 2750000 },
        { id: 43, label : "3000000",  value: 3000000 },
        { id: 44, label : "3500000",  value: 3500000 },
        { id: 45, label : "4000000",  value: 4000000 },
        { id: 46, label : "4500000",  value: 4500000 },
        { id: 47, label : "5000000",  value: 5000000 },
        { id: 48, label : "6000000",  value: 6000000 },
        { id: 49, label : "7000000",  value: 7000000 },
        { id: 50, label : "8000000",  value: 8000000 },
        { id: 51, label : "9000000",  value: 9000000 },
        { id: 52, label : "10000000",  value: 10000000 },
        { id: 53, label : "11000000",  value: 11000000 },
        { id: 54, label : "12000000",  value: 12000000 },
        { id: 55, label : "13000000",  value: 13000000 },
        { id: 56, label : "14000000",  value: 14000000 },
        { id: 57, label : "15000000",  value: 15000000 },
      ],
      maxPrice: [
        { id: 0, label : "Any",  value: null },
        { id: 1, label : "50000",  value: 50000 },
        { id: 2, label : "75000",  value: 75000 },
        { id: 3, label : "100000",  value: 100000 },
        { id: 4, label : "125000",  value: 125000 },
        { id: 5, label : "150000",  value: 150000 },
        { id: 6, label : "175000",  value: 175000 },
        { id: 7, label : "200000",  value: 200000 },
        { id: 8, label : "225000",  value: 225000 },
        { id: 9, label : "250000",  value: 250000 },
        { id: 10, label : "275000",  value: 275000 },
        { id: 11, label : "300000",  value: 300000 },
        { id: 12, label : "325000",  value: 325000 },
        { id: 13, label : "350000",  value: 350000 },
        { id: 14, label : "375000",  value: 375000 },
        { id: 15, label : "400000",  value: 400000 },
        { id: 16, label : "425000",  value: 425000 },
        { id: 17, label : "450000",  value: 450000 },
        { id: 18, label : "475000",  value: 475000 },
        { id: 19, label : "500000",  value: 500000 },
        { id: 20, label : "550000",  value: 550000 },
        { id: 21, label : "600000",  value: 600000 },
        { id: 22, label : "650000",  value: 650000 },
        { id: 23, label : "700000",  value: 700000 },
        { id: 24, label : "750000",  value: 750000 },
        { id: 25, label : "800000",  value: 800000 },
        { id: 26, label : "850000",  value: 850000 },
        { id: 27, label : "900000",  value: 900000 },
        { id: 28, label : "950000",  value: 950000 },
        { id: 29, label : "1000000",  value: 1000000 },
        { id: 30, label : "1100000",  value: 1100000 },
        { id: 31, label : "1200000",  value: 1200000 },
        { id: 32, label : "1300000",  value: 1300000 },
        { id: 33, label : "1400000",  value: 1400000 },
        { id: 34, label : "1500000",  value: 1500000 },
        { id: 35, label : "1600000",  value: 1600000 },
        { id: 36, label : "1700000",  value: 1700000 },
        { id: 37, label : "1800000",  value: 1800000 },
        { id: 38, label : "1900000",  value: 1900000 },
        { id: 39, label : "2000000",  value: 2000000 },
        { id: 40, label : "2250000",  value: 2250000 },
        { id: 41, label : "2500000",  value: 2500000 },
        { id: 42, label : "2750000",  value: 2750000 },
        { id: 43, label : "3000000",  value: 3000000 },
        { id: 44, label : "3500000",  value: 3500000 },
        { id: 45, label : "4000000",  value: 4000000 },
        { id: 46, label : "4500000",  value: 4500000 },
        { id: 47, label : "5000000",  value: 5000000 },
        { id: 48, label : "6000000",  value: 6000000 },
        { id: 49, label : "7000000",  value: 7000000 },
        { id: 50, label : "8000000",  value: 8000000 },
        { id: 51, label : "9000000",  value: 9000000 },
        { id: 52, label : "10000000",  value: 10000000 },
        { id: 53, label : "11000000",  value: 11000000 },
        { id: 54, label : "12000000",  value: 12000000 },
        { id: 55, label : "13000000",  value: 13000000 },
        { id: 56, label : "14000000",  value: 14000000 },
        { id: 57, label : "15000000",  value: 15000000 },
      ],
      minRentalEstimate: [
        { id: 0, label : "Any",  value: null },
        { id: 1, label : "100",  value: 100 },
        { id: 2, label : "200",  value: 200 },
        { id: 3, label : "300",  value: 300 },
        { id: 4, label : "400",  value: 400 },
        { id: 5, label : "500",  value: 500 },
        { id: 6, label : "600",  value: 600 },
        { id: 7, label : "700",  value: 700 },
        {id: 8,  label : "800",  value: 800},
        {id: 9,  label : "1000", value: 1000},
        {id: 10, label : "1250", value: 1250},
        {id: 11, label : "1500", value: 1500},
        {id: 12, label : "1750", value: 1750},
        {id: 13, label : "2000", value: 2000},
        {id: 14, label : "2250", value: 2250},
        {id: 16, label : "3000", value: 3000},
        {id: 17, label : "3500", value: 3500},
        {id: 18, label : "4000", value: 4000},
        {id: 19, label : "4500", value: 4500},
        {id: 20, label : "5000", value: 5000},
      ],
      maxRentalEstimate: [
        { id: 0, label : "Any", value: null },
        { id: 1, label : "100",  value: 100 },
        { id: 2, label : "200",  value: 200 },
        { id: 3, label : "300",  value: 300 },
        { id: 4, label : "400",  value: 400 },
        { id: 5, label : "500",  value: 500 },
        { id: 6, label : "600",  value: 600 },
        { id: 7, label : "700",  value: 700 },
        {id: 8,  label : "800",  value: 800},
        {id: 9,  label : "1000", value: 1000},
        {id: 10, label : "1250", value: 1250},
        {id: 11, label : "1500", value: 1500},
        {id: 12, label : "1750", value: 1750},
        {id: 13, label : "2000", value: 2000},
        {id: 14, label : "2250", value: 2250},
        {id: 16, label : "3000", value: 3000},
        {id: 17, label : "3500", value: 3500},
        {id: 18, label : "4000", value: 4000},
        {id: 19, label : "4500", value: 4500},
        {id: 20, label : "5000", value: 5000},
      ],
      minLandSize: [
        { id: 0, label : "Any",  value: null },
        { id: 1, label : "100",  value: 100 },
        { id: 2, label : "200",  value: 200 },
        { id: 3, label : "300",  value: 300 },
        { id: 4, label : "400",  value: 400 },
        { id: 5, label : "500",  value: 500 },
        { id: 6, label : "600",  value: 600 },
        { id: 7, label : "700",  value: 700 },
        {id: 8,  label : "800",  value: 800},
        {id: 9,  label : "1000", value: 1000},
        {id: 10, label : "1250", value: 1250},
        {id: 11, label : "1500", value: 1500},
        {id: 12, label : "1750", value: 1750},
        {id: 13, label : "2000", value: 2000},
        {id: 14, label : "2250", value: 2250},
        {id: 16, label : "3000", value: 3000},
        {id: 17, label : "3500", value: 3500},
        {id: 18, label : "4000", value: 4000},
        {id: 19, label : "4500", value: 4500},
        {id: 20, label : "5000", value: 5000},
      ],
      maxLandSize: [
        { id: 0, label : "Any", value: null },
        { id: 1, label : "100",  value: 100 },
        { id: 2, label : "200",  value: 200 },
        { id: 3, label : "300",  value: 300 },
        { id: 4, label : "400",  value: 400 },
        { id: 5, label : "500",  value: 500 },
        { id: 6, label : "600",  value: 600 },
        { id: 7, label : "700",  value: 700 },
        {id: 8,  label : "800",  value: 800},
        {id: 9,  label : "1000", value: 1000},
        {id: 10, label : "1250", value: 1250},
        {id: 11, label : "1500", value: 1500},
        {id: 12, label : "1750", value: 1750},
        {id: 13, label : "2000", value: 2000},
        {id: 14, label : "2250", value: 2250},
        {id: 16, label : "3000", value: 3000},
        {id: 17, label : "3500", value: 3500},
        {id: 18, label : "4000", value: 4000},
        {id: 19, label : "4500", value: 4500},
        {id: 20, label : "5000", value: 5000},
      ],
      minBuildSize: [
        { id: 0, label : "Any", value: null },
        { id: 1, label : "100", value: 100 },
        { id: 2, label : "200", value: 200 },
        { id: 3, label : "300", value: 300 },
        { id: 4, label : "400", value: 400 },
        { id: 5, label : "500", value: 500 },
        { id: 6, label : "600", value: 600 },
        { id: 7, label : "700", value: 700 },
        { id: 8, label : "800", value: 800 }
      ],
      maxBuildSize: [
        { id: 0, label : "Any", value: null },
        { id: 1, label : "100", value: 100 },
        { id: 2, label : "200", value: 200 },
        { id: 3, label : "300", value: 300 },
        { id: 4, label : "400", value: 400 },
        { id: 5, label : "500", value: 500 },
        { id: 6, label : "600", value: 600 },
        { id: 7, label : "700", value: 700 },
        { id: 8, label : "800", value: 800 }
      ],
      minBedrooms: [
        { id: 0, label: "Any", value: null },
        { id: 1, label: "1", value: 1 },
        { id: 2, label: "2", value: 2 },
        { id: 3, label: "3", value: 3 },
        { id: 4, label: "4", value: 4 },
        { id: 5, label: "5", value: 5 },
        { id: 6, label: "6", value: 6 }
      ],
      maxBedrooms: [
        { id: 0, label : "Any", value: null },
        { id: 1, label : "1", value: 1 },
        { id: 2, label : "2", value: 2 },
        { id: 3, label : "3", value: 3 },
        { id: 4, label : "4", value: 4 },
        { id: 5, label : "5", value: 5 },
        { id: 6, label : "6", value: 6 }
      ],
      bathrooms: [
        { id: 0, label:"Any", value: null },
        { id: 1, label:"1+",  value: 1 },
        { id: 2, label:"2+",  value: 2 },
        { id: 3, label:"3+",  value: 3 },
        { id: 4, label:"4+",  value: 4 },
        { id: 5, label:"5+",  value: 5 },
        { id: 6, label:"6+",  value: 6 }
      ],
      carSpaces: [
        { id: 0, label: "Any", value: null },
        { id: 1, label: "1+", value: 1 },
        { id: 2, label: "2+", value: 2 },
        { id: 3, label: "3+", value: 3 },
        { id: 4, label: "4+", value: 4 },
        { id: 5, label: "5+", value: 5 },
        { id: 6, label: "6+", value: 6 }
      ],
      address: "",
      location: [],
      latitude: 0,
      longitude: 0,
      thisMap: {},
      geoCode: { lat: 0, lng: 0 },
      checkedAllPropertyType: false,
      isPropertyTypeIndeterminate: true,
      propertyTypes: propertyTypeOptions,
      propertyTypeChipOptions: propertyTypeChipOptions,
      checkedPropertyTypes: [],
    };
  },
  props: {
    isHomePage: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  methods: {
    ...mapActions("home", ["getSearchSuburbsDropdown"]),
    goSearch() {
      //get for SA only for now, and fix up post go live
      console.log(
        "this.searchFiltersForm.searchSuburb",
        this.searchFiltersForm.searchSuburb
      );
      if (this.searchFiltersForm.searchSuburb) {
        this.searchFiltersForm.searchSuburb =
          this.searchFiltersForm.searchSuburb.replace(" SA, Australia", "");
        console.log("AAAA");
      }

      console.log(
        "2this.searchFiltersForm.searchSuburb",
        this.searchFiltersForm.searchSuburb
      );
      //clear the state, from search, to search for regions
      if (this.searchFiltersForm.searchSuburb) {
        var str_array = this.searchFiltersForm.searchSuburb.split(",");
        this.searchFiltersForm.searchSuburb = str_array[0];
      }

      console.log(
        "3this.searchFiltersForm.searchSuburb",
        this.searchFiltersForm.searchSuburb
      );
      //clear the state and postcode, from search, to search for suburbs
      if (this.searchFiltersForm.searchSuburb) {
        this.searchFiltersForm.searchSuburb =
          this.searchFiltersForm.searchSuburb.replace(", SA", "");
      }

      if (this.searchFiltersForm.searchSuburb == "South Australia, Australia") {
        this.searchFiltersForm.searchSuburb = "";
        console.log("BBBB");
      }

      if(this.checkedPropertyTypes.length != 0){
        this.searchFiltersForm.propertyTypeList = this.checkedPropertyTypes;
      }

      this.searchFiltersForm.sort = sessionStorage.searchSort;
      sessionStorage.setItem(
        "searchFiltersForm",
        JSON.stringify(this.searchFiltersForm)
      );
      this.isSearchFiltersDialogVisible = false;
      if (this.$route.path !== "/property/search/results") {
        this.$router.push("/property/search/results");
      } else {
        this.$router.go();
      }
    },
    clearFilters(){
      this.searchFiltersForm.searchType = this.searchType;
      this.searchFiltersForm.sort = "time";
      this.searchFiltersForm.saleType = 1;
      this.searchFiltersForm.propertyTypeList = [];
      this.searchFiltersForm.minPrice = null;
      this.searchFiltersForm.maxPrice = null;
      this.searchFiltersForm.minRentalEstimate = null;
      this.searchFiltersForm.maxRentalEstimate = null;
      this.searchFiltersForm.minLandSize = null;
      this.searchFiltersForm.maxLandSize = null;
      this.searchFiltersForm.minBuildSize = null;
      this.searchFiltersForm.maxBuildSize = null;
      this.searchFiltersForm.minBedrooms = null;
      this.searchFiltersForm.maxBedrooms = null;
      this.searchFiltersForm.bathrooms = null;
      this.searchFiltersForm.carSpaces = null;
      this.searchFiltersForm.searchSuburb = "";

      this.checkedPropertyTypes = [];
      this.handleCheckedPropertyTypeChange([]);

      sessionStorage.setItem("searchFiltersForm", JSON.stringify(this.searchFiltersForm));
    },
    brightenKeyword(val, keyword) {
      const Reg = new RegExp(keyword, "i");
      if (val) {
        return val.replace(
          Reg,
          `<span style="color: #000;font-weight:600;">${keyword}</span>`
        );
      }
    },

    handleLocationSelect(item) {
      console.log("=============item=================", item);
      this.searchFiltersForm.searchSuburb = item.value;
    },
    queryLocationSearchAsync(keyword) {
      // Search address
      var that = this;
      const request = {
        input: keyword,
        componentRestrictions: {
          country: "au",
        },
      };
      const AutocompleteService =
        new window.google.maps.places.AutocompleteService();
      AutocompleteService.getPlacePredictions(request, (results, status) => {
        console.log(results);
        if (status === "OK" && results) {
          that.location = results;
        } else {
          that.location = [];
        }
      });
    },
    queryLocationSearch(queryString, cb) {
      if (!queryString) {
        this.location = [];
        this.latitude = 0;
        this.longitude = 0;
        cb([]);
        return;
      }
      this.queryLocationSearchAsync(queryString);
      setTimeout(() => {
        const arr = this.location.map((item) => {
          return Object.assign(item, { value: item.description });
        });
        cb(arr);
      }, 1000);
    },
    getSearchSuburbsDropdownValues() {
      this.getSearchSuburbsDropdown({
        params: {
          page: this.curPage,
          pageSize: this.pageSize,
          searchType:
            this.searchFiltersForm.searchType == "sold" ? "sold" : "buy",
        },
        callback: this.callback,
      });
    },
    callback(resp, status) {
      if (resp.data.code == 0) {
        this.suburbList = resp.data.data;
      } else {
        Utils.alert("", resp.message, "error");
      }
    },
    handleSearchType(type) {
      if (type == "buy") {
        this.searchFiltersForm.searchType = "buy";
      } else if (type == "sold") {
        this.searchFiltersForm.searchType = "sold";
      } else {
        this.searchFiltersForm.searchType = "buy";
      }
      this.getSearchSuburbsDropdownValues();
    },
    handlePropertyTypeCheckAllChange(val) {
      this.checkedPropertyTypes = val ? propertyTypeOptions : [];
      this.searchFiltersForm.propertyTypeList = this.checkedPropertyTypes;
      this.isPropertyTypeIndeterminate = false;
    },
    handleCheckedPropertyTypeChange(value) {
      console.log('value', value);
      let checkedCount = value.length;
      this.checkedAllPropertyType = checkedCount === this.propertyTypes.length;
      this.isPropertyTypeIndeterminate = checkedCount > 0 && checkedCount < this.propertyTypes.length;
    },
    handleQuickSearch(type){

      let options = sessionStorage.searchFiltersForm
        ? JSON.parse(sessionStorage.searchFiltersForm)
        : this.searchFiltersForm;

      this.searchFiltersForm= options;
      this.searchFiltersForm.propertyTypeList = [type];
      sessionStorage.setItem("isSearch", "1");
      sessionStorage.setItem(
        "searchFiltersForm",
        JSON.stringify(this.searchFiltersForm)
      );
      this.isSearchFiltersDialogVisible = false;
      if (this.$route.path !== "/property/search/results") {
        this.$router.push("/property/search/results");
      } else {
        this.$router.go();
      }
    },
    setFilterBadgeValueCount(){
      const { activeFilterCount } = this.getFilterGroups(this.searchFiltersForm);
      this.filterBadgeValueCount = activeFilterCount;

    },
    getFilterGroups(searchFiltersForm) {
      // Define filter groups
      const filterGroups = {
        'property': {
          filters: ['propertyTypeList'],
          active: false,
          validate: (value) => {
            if (!value || !Array.isArray(value)) return false;
            if (value.length === 0) return false;
            if (value.length === 1 && (value[0] === 'All' || value[0] === 'ALL')) return false;
            return true;
          }
        },
        'price': {
          filters: ['minPrice', 'maxPrice'],
          active: false,
          validate: (value) => value !== null && value !== undefined && value !== ''
        },
        'rental': {
          filters: ['minRentalEstimate', 'maxRentalEstimate'],
          active: false,
          validate: (value) => value !== null && value !== undefined && value !== ''
        },
        'land': {
          filters: ['minLandSize', 'maxLandSize'],
          active: false,
          validate: (value) => value !== null && value !== undefined && value !== ''
        },
        'build': {
          filters: ['minBuildSize', 'maxBuildSize'],
          active: false,
          validate: (value) => value !== null && value !== undefined && value !== ''
        },
        'bedrooms': {
          filters: ['minBedrooms', 'maxBedrooms'],
          active: false,
          validate: (value) => value !== null && value !== undefined && value !== ''
        },
        'bathrooms': {
          filters: ['bathrooms'],
          active: false,
          validate: (value) => value !== null && value !== undefined && value !== ''
        },
        'carSpaces': {
          filters: ['carSpaces'],
          active: false,
          validate: (value) => value !== null && value !== undefined && value !== ''
        }
      };

      // Calculate active groups
      Object.keys(filterGroups).forEach(groupKey => {
        const group = filterGroups[groupKey];
        group.active = group.filters.some(filter =>
          group.validate(searchFiltersForm[filter])
        );
      });

      // Count total active filter groups
      const activeFilterCount = Object.values(filterGroups)
        .filter(group => group.active)
        .length;

      return {
        filterGroups,
        activeFilterCount
      };
    },
    formatArea(value) {
      if (value === 'Any') return 'Any';
      const formattedNumber = Intl.NumberFormat('en-AU', {
        maximumFractionDigits: 0
      }).format(value);
      return `${formattedNumber} m²`;
    },
    formatAreaHtml(value) {
      if (value === 'Any') return 'Any';
      const formattedNumber = Intl.NumberFormat('en-AU', {
        maximumFractionDigits: 0
      }).format(value);
      return `${formattedNumber} m<sup>2</sup>`;
    },
    formatCurrency(value) {
      if (value === 'Any') return 'Any';
      const formatted = Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        maximumFractionDigits: 0
      }).format(value);
      return formatted.replace('$', '$');
    }
  },
  mounted() {
    let options = sessionStorage.searchFiltersForm
      ? JSON.parse(sessionStorage.searchFiltersForm)
      : this.searchFiltersForm;

    this.searchFiltersForm = options;
    if (options.searchType) {
      this.searchFiltersForm.searchType = options.searchType;
      this.searchType = options.searchType;
    }
    if (options.searchSuburb) {
      this.searchFiltersForm.searchSuburb = options.searchSuburb;
    } else {
      //default to Australia
      this.searchFiltersForm.searchSuburb = "Australia";
    }

    if (options.propertyTypeList) {
      this.searchFiltersForm.propertyTypeList = options.propertyTypeList;
    }
    this.getSearchSuburbsDropdownValues();
    this.setFilterBadgeValueCount();
  },
  getLocationDetail(placeId) {
    // Obtain details based on the address ID
    const divEle = document.createElement("div");
    const serve = new window.google.maps.places.PlacesService(divEle);
    var that = this;
    serve.getDetails(
      {
        placeId: placeId,
      },
      (result, status) => {
        if (status === "OK" && result) {
          that.geoCode.value.lat = result.geometry.location.lat();
          that.geoCode.value.lng = result.geometry.location.lng();
        }
      }
    );
  },
  initMap(id = "googleMap", lat, lng, popupData) {
    const uluru = { lat: -33.91722, lng: 151.23064 };
    // The map, centered at Uluru
    const map = new window.google.maps.Map(document.getElementById(id), {
      zoom: 16,
      center: uluru,
      disableDefaultUI: true,
    });
    this.thisMap.value = map;
  },
};
</script>

<template>
  <el-row style="margin-top: 24px">
    <el-form :model="searchFiltersForm">
      <el-col
        :span="24"
        style="display: flex; flex-direction: column; text-align: center"
      >
        <span class="tab-style">Buy Tomorrow's Real Estate...Today</span>
      </el-col>
      <el-row>
        <div class="property-type-chips-wrapper">
          <span :class="isHomePage? 'property-type-chip light': 'property-type-chip'" v-for="item in propertyTypeChipOptions" :key="item.key" @click="handleQuickSearch(item.key)">{{item.value}}</span>
        </div>
      </el-row>
      <el-row>
        <el-col :span="6" :xs="8" style="padding: 5px 5px;">
          <el-form-item style="margin-bottom: 5px">
            <el-select
              v-model="searchType"
              class="ig-autocompleteInput_form type-filter-select"
              placeholder="Select"
              @change="handleSearchType($event)"
            >
              <el-option key="buy" label="Buy" value="buy"></el-option>
              <el-option key="sold" label="Sold" value="sold"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="18" :xs="16" style="padding: 5px 5px">
          <el-form-item style="margin-bottom: 5px">
            <el-select
              v-model="searchFiltersForm.searchSuburb"
              class="ig-autocompleteInput_form search-filter-select"
              clearable
              filterable
              placeholder="Select"
            >
              <el-option
                v-for="(item, index) in this.suburbList"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="padding: 5px 5px">
          <el-row :gutter="20">
            <el-col :span="12" style="display: flex; flex-direction: column">
                <el-button
                  :class="isHomePage ? 'filter-button' : 'search-button'"
                  type="primary"
                  @click="isSearchFiltersDialogVisible = true"
                >
                  Filters  <el-badge v-if="filterBadgeValueCount > 0" is-dot class="filter-button-badge"></el-badge>
                </el-button>
            </el-col>
            <el-col :span="12" style="display: flex; flex-direction: column">
              <el-button
                class="search-button"
                type="primary"
                @click="goSearch()"
              >
                Search
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-dialog
                :visible.sync="isSearchFiltersDialogVisible"
                fullscreen
              >
                <template #title>
        <span
          style="font: 600 30px DINosaur-a; color: #003333; border-color: #003333"
        >Filters</span
        >
                </template>
                <el-row>
                  <el-form :model="searchFiltersForm">
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col :span="24">
                          <el-autocomplete
                            v-model="searchFiltersForm.searchSuburb"
                            :fetch-suggestions="queryLocationSearch"
                            :style="{ height: '48px' }"
                            class="ig-autocompleteInput_form ig-autocompleteInput"
                            placeholder="Enter a suburb, city, or state"
                            popper-class="ig-autocompleteInput"
                            @select="handleLocationSelect"
                          >
                            <template v-slot="{ item }">
                              <span
                                v-html="brightenKeyword(item.value, address)"
                              ></span>
                            </template>
                          </el-autocomplete>
                        </el-col>
                      </el-form-item>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            justify-content: left;
                            padding-right: 10px;
                          "
                        >
                          <span
                            class="filter-sub-title-header"
                            >Property Type</span
                          >
                        </el-col>
                        <el-row>
                          <!--                  Property Type Checkbox-->
                          <el-col :span="12">
                            <el-checkbox class="property-type-checkbox-group" :indeterminate="isPropertyTypeIndeterminate" v-model="checkedAllPropertyType" @change="handlePropertyTypeCheckAllChange">All Types</el-checkbox>
                          </el-col>
                          <el-checkbox-group class="property-type-checkbox-group" v-model="searchFiltersForm.propertyTypeList" @change="handleCheckedPropertyTypeChange">
                            <el-col :span="12">
                              <el-checkbox label="Apartments" key="Apartments">Apartments</el-checkbox>
                            </el-col>
                            <el-col :span="12">
                              <el-checkbox label="Townhouses" key="Townhouses">Townhouses</el-checkbox>
                            </el-col>
                            <el-col :span="12">
                              <el-checkbox label="House & Land" key="House & Land">House &amp; Land</el-checkbox>
                            </el-col>
                            <el-col :span="12">
                              <el-checkbox  label="House" key="House">House</el-checkbox>
                            </el-col>
                            <el-col :span="12">
                              <el-checkbox  label="Land" key="Land">Land</el-checkbox>
                            </el-col>
                          </el-checkbox-group>
                        </el-row>
                      </el-form-item>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            justify-content: left;
                            padding-right: 10px;
                          "
                        >
                          <span
                            class="filter-sub-title-header"
                            >Price</span
                          >
                        </el-col>
                        <el-col :span="24">
                          <span
                            class="filter-sub-title-description"
                            >Min</span
                          >
                          <el-select
                            v-model="searchFiltersForm.minPrice"
                            :popper-append-to-body="false"
                            placeholder="Any"
                            style="display: inline"
                          >
                            <el-option
                              v-for="price in minPrice.filter(price => searchFiltersForm.maxPrice === null || price.value <= searchFiltersForm.maxPrice || price.value === null)"
                              :key="price.id"
                              :label="formatCurrency(price.label)"
                              :value="price.value"
                            ></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="24" style="margin-top: 20px">
                          <span
                            class="filter-sub-title-description"
                            >Max</span
                          >
                          <el-select
                            v-model="searchFiltersForm.maxPrice"
                            :popper-append-to-body="false"
                            placeholder="Any"
                            style="display: inline"
                          >
                            <el-option
                              v-for="price in maxPrice.filter(price => searchFiltersForm.minPrice === null || price.value >= searchFiltersForm.minPrice || price.value === null)"
                              :key="price.id"
                              :label="formatCurrency(price.label)"
                              :value="price.value"
                            ></el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            justify-content: left;
                            padding-right: 10px;
                          "
                        >
                          <span
                            class="filter-sub-title-header"
                            >Rental Estimate</span
                          >
                        </el-col>
                        <el-col :span="24">
                          <el-col :span="24">
                            <span
                              class="filter-sub-title-description"
                              >Min</span
                            >
                            <el-select
                              v-model="searchFiltersForm.minRentalEstimate"
                              :popper-append-to-body="false"
                              placeholder="Any"
                              style="display: inline"
                            >
                              <el-option
                                v-for="price in minRentalEstimate.filter(rental => searchFiltersForm.maxRentalEstimate === null || rental.value <= searchFiltersForm.maxRentalEstimate || rental.value === null)"
                                :key="price.id"
                                :label="formatCurrency(price.label)"
                                :value="price.value"
                              ></el-option>
                            </el-select>
                          </el-col>
                          <el-col :span="24" style="margin-top: 20px">
                            <span
                              class="filter-sub-title-description"
                              >Max</span
                            >
                            <el-select
                              v-model="searchFiltersForm.maxRentalEstimate"
                              :popper-append-to-body="false"
                              placeholder="Any"
                              style="display: inline"
                            >
                              <el-option
                                v-for="price in maxRentalEstimate.filter(rental => searchFiltersForm.minRentalEstimate === null || rental.value >= searchFiltersForm.minRentalEstimate || rental.value === null)"
                                :key="price.id"
                                :label="formatCurrency(price.label)"
                                :value="price.value"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-col>
                      </el-form-item>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            justify-content: left;
                            padding-right: 10px;
                          "
                        >
                          <span
                            class="filter-sub-title-header"
                            >Land Size</span
                          >
                        </el-col>
                        <el-col :span="24">
                          <el-col :span="24">
                            <span
                              class="filter-sub-title-description"
                              >Min</span
                            >
                            <el-select
                              v-model="searchFiltersForm.minLandSize"
                              :popper-append-to-body="false"
                              placeholder="Any"
                              style="display: inline"
                            >
                              <el-option
                                v-for="size in minLandSize.filter(size => searchFiltersForm.maxLandSize === null || size.value <= searchFiltersForm.maxLandSize || size.value === null)"
                                :key="size.id"
                                :label="formatArea(size.label)"
                                :value="size.value"
                                v-html="formatAreaHtml(size.label)"
                              ></el-option>
                            </el-select>
                          </el-col>
                          <el-col :span="24" style="margin-top: 20px">
                            <span
                             class="filter-sub-title-description"
                              >Max</span
                            >
                            <el-select
                              v-model="searchFiltersForm.maxLandSize"
                              :popper-append-to-body="false"
                              placeholder="Any"
                              style="display: inline"
                            >
                              <el-option
                                v-for="size in maxLandSize.filter(size => searchFiltersForm.minLandSize === null ||size.value >= searchFiltersForm.minLandSize || size.value === null)"
                                :key="size.id"
                                :label="formatArea(size.label)"
                                :value="size.value"
                                v-html="formatAreaHtml(size.label)"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-col>
                      </el-form-item>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            justify-content: left;
                            padding-right: 10px;
                          "
                        >
                          <span
                            class="filter-sub-title-header"
                            >Build Size</span
                          >
                        </el-col>
                        <el-col :span="24">
                          <el-col :span="24">
                            <span
                              class="filter-sub-title-description"
                              >Min</span
                            >
                            <el-select
                              v-model="searchFiltersForm.minBuildSize"
                              :popper-append-to-body="false"
                              placeholder="Any"
                              style="display: inline"
                            >
                              <el-option
                                v-for="size in minBuildSize.filter(size => searchFiltersForm.maxBuildSize === null || size.value <= searchFiltersForm.maxBuildSize || size.value === null)"
                                :key="size.id"
                                :label="formatArea(size.label)"
                                :value="size.value"
                                v-html="formatAreaHtml(size.label)"
                              ></el-option>
                            </el-select>
                          </el-col>
                          <el-col :span="24" style="margin-top: 20px">
                            <span
                              class="filter-sub-title-description"
                              >Max</span
                            >
                            <el-select
                              v-model="searchFiltersForm.maxBuildSize"
                              :popper-append-to-body="false"
                              placeholder="Any"
                              style="display: inline"
                            >
                              <el-option
                                v-for="size in maxBuildSize.filter(size => searchFiltersForm.minBuildSize === null || size.value >= searchFiltersForm.minBuildSize || size.value === null)"
                                :key="size.id"
                                :label="formatArea(size.label)"
                                :value="size.value"
                                v-html="formatAreaHtml(size.label)"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-col>
                      </el-form-item>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            justify-content: left;
                            padding-right: 10px;
                          "
                        >
                          <span
                            class="filter-sub-title-header"
                            >Bedrooms</span
                          >
                        </el-col>
                        <el-col :span="24">
                          <el-col :span="24">
                            <span
                              class="filter-sub-title-description"
                              >Min</span
                            >
                            <el-select
                              v-model="searchFiltersForm.minBedrooms"
                              :popper-append-to-body="false"
                              placeholder="Any"
                              style="display: inline"
                            >
                              <el-option
                                v-for="bedroom in minBedrooms"
                                :key="bedroom.id"
                                :label="bedroom.label"
                                :value="bedroom.value"
                              ></el-option>
                            </el-select>
                          </el-col>
                          <el-col :span="24" style="margin-top: 20px">
                            <span
                              class="filter-sub-title-description"
                              >Max</span
                            >
                            <el-select
                              v-model="searchFiltersForm.maxBedrooms"
                              placeholder="Any"
                              style="display: inline"
                              :popper-append-to-body="false"
                            >
                              <el-option
                                v-for="bedroom in maxBedrooms.filter(bedroom => searchFiltersForm.minBedrooms || bedroom.value >= searchFiltersForm.minBedrooms || bedroom.value === null)"
                                :key="bedroom.id"
                                :label="bedroom.label"
                                :value="bedroom.value"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-col>
                      </el-form-item>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            justify-content: left;
                            padding-right: 10px;
                          "
                        >
                          <span
                            class="filter-sub-title-header"
                            >Bathrooms</span
                          >
                        </el-col>
                        <el-col :span="24">
                          <el-col :span="24">
                            <el-select
                              v-model="searchFiltersForm.bathrooms"
                              placeholder="Any"
                              style="display: inline"
                              :popper-append-to-body="false"
                            >
                              <el-option
                                v-for="bathroom in bathrooms"
                                :key="bathroom.id"
                                :label="bathroom.label"
                                :value="bathroom.value"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-col>
                      </el-form-item>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            justify-content: left;
                            padding-right: 10px;
                          "
                        >
                          <span
                            class="filter-sub-title-header"
                            >Car Spaces</span
                          >
                        </el-col>
                        <el-col :span="24">
                          <el-col :span="24">
                            <el-select
                              v-model="searchFiltersForm.carSpaces"
                              placeholder="Any"
                              style="display: inline"
                              :popper-append-to-body="false"
                            >
                              <el-option
                                v-for="spaces in carSpaces"
                                :key="spaces.id"
                                :label="spaces.label"
                                :value="spaces.value"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-col>
                      </el-form-item>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row :gutter="10">
                      <el-form-item>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            flex-direction: column;
                            margin-top: 26px;
                          "
                        >
                            <el-button type="primary" @click="clearFilters()"
                                       style="color: #003333; text-align: center; border: none; background-color: #FFFFFF; padding: 14px 60px; font: 500 20px DINosaur-a, sans-serif;">
                              Clear filters
                            </el-button>
                        </el-col>
                        <el-col
                          :span="24"
                          style="
                            display: flex;
                            flex-direction: column;
                            margin-top: 20px;
                          "
                        >
                          <el-button
                            type="primary"
                            @click="goSearch()"
                            class="search-button">
                            Search
                          </el-button>
                        </el-col>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </el-row>
              </el-dialog>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </el-row>
</template>

<style scoped>
.search-button{
  color: #ffffff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  padding: 14px 60px;
  font: 500 20px DINosaur-a, sans-serif;
}
.filter-button{
  color: #003333;
  text-align: center;
  background-color: #ffffff;
  border: 3px solid #ffffff;
  padding: 14px 60px;
  font: 500 20px DINosaur-a, sans-serif;
}
/deep/ .el-badge__content.is-dot  {
  height: 5px;
  width: 5px;
}
.search-style {
  color: #fff;
  font-family: DINosaur-a, sans-serif;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  padding: 0 16px;
}

.filter-sub-title-header {
  color: #003333;
  align-self: center;
  padding: 30px 0 30px 0;
  font: 500 20px DINosaur-a, sans-serif;
}
.filter-sub-title-description {
  font: 400 16px DINosaur-a, sans-serif;
  display: flex;
  justify-content: left;
}

.search-properties-title {
  color: #003333;
  align-self: center;
  padding: 30px 0 30px 0;
  font: 600 40px DINosaur-a, sans-serif;
}
.property-type-chips-wrapper{
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-gap: 5px;
}
.property-type-chip {
  color: #003333;
  white-space: nowrap;
  opacity: 0.8;
  border-radius: 40px;
  background-color: #c6c5c5;
  text-align: center;
  padding: 8px 0;
  font: 400 12px/125% DINosaur-a, sans-serif;
  cursor: pointer;
}
.property-type-chip:hover {
  background-color: #9d9d9d;
}

.property-type-chip.light:hover {
  background-color: #ffffff;
}

.tab-style {
  color: #ffffff;
  font-family: DINosaur-a, sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.underline {
  background-color: #003333;
  margin-top: 4px;
  height: 4px;
  width: inherit;
}

.ig-autocompleteInput_form {
  width: 100%;
}

.ig-autocompleteInput_form /deep/ .el-input__inner {
  height: 48px;
  font: 500 16px DINosaur-a, sans-serif;
}

/* property type checkbox */
.property-type-checkbox-group{
  color: #003333;
  border-color: #003333;
}
.property-type-checkbox-group :hover {
  border-color: #003333 !important;
}
.property-type-checkbox-group /deep/ .el-checkbox__label {
  color: #003333;
}
.property-type-checkbox-group /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #003333 !important;
  border-color: #003333 !important;
}
.property-type-checkbox-group /deep/ .el-checkbox__input.is-checked .el-checkbox__inner  {
  background-color: #003333 !important;
  border-color: #003333 !important;

}

el-input el-input--suffix /deep/ .el-input__inner {
  border: none;
}

.element-center{
  display: flex;
  justify-content: center;
}
.divider-wrapper{
  width: 4px;
  height: 3em;
  background-color: #003333;
}


.cursor-pointer {
  cursor: pointer;
}
.el-select /deep/ .el-input__inner {
  color: #003333;
  font: 500 16px DINosaur-a, sans-serif;
}

.el-select-dropdown__item {
  color: #003333;
  font: 500 16px DINosaur-a, sans-serif !important;
}
.el-select-dropdown__item.selected {
  color: #003333;
  font-weight: 600;

}

@media only screen and (max-width: 600px) {
  .search-filter-select /deep/ .el-input__inner,
  .type-filter-select /deep/ .el-input__inner {
    height: 30px ;
    font: 500 12px DINosaur-a, sans-serif;
  }
  .search-button, .filter-button{
    padding: 10px 60px;
    font: 500 12px DINosaur-a, sans-serif;
  }
  .el-select-dropdown__item {
    font: 500 12px DINosaur-a, sans-serif !important;
  }
  .search-style {
    color: #fff;
    font-family: DINosaur-a, sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    padding: 0 16px;
  }

  .tab-style {
    font-size: 18px;
  }

  .property-type-select {
    color: #003333;
    font-family: DINosaur-a, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .underline {
    background-color: #003333;
    margin-top: 4px;
    height: 4px;
    width: inherit;
  }
}
.el-dialog {
  .el-dialog__body {
    padding: 0 20px !important;
  }
}
.el-select-dropdown__item {
  color: #003333 !important;
  background-color: #ffffff !important;
}
.el-select-dropdown__item:hover {
  color: #ffffff !important;
  background-color: #003333 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/package/searchSection.vue